const skuToIgnoreCOD = [
"6710218555590",  
"6710218522822",  
"6710219243718",  
"6710218752198",  
"6710218817734",  
"6710219440326",  
"6710219473094",  
"6710217670854",  
"6710215278790",  
"6710215213254",  
"6710217801926",  
"6710216786118",  
"6710218784966",  
"6710218719430",  
"6710218850502",  
"6710218588358",  
"6710218621126",  
"6710219407558",  
"6710219374790",  
"6710218686662",  
"6710217834694",  
"6710217769158",  
"6710215377094",  
"6710215442630",  
"6710217703622",  
"6710218916038",  
"6710218981574",  
"6710218883270",  
"6710215966918",  
"6710215016646",  
"6710214918342",  
"6710215409862",  
"6710214983878",  
"6710215868614",  
"6710217375942",  
"6710217179334",  
"6710217408710",  
"6710217048262",  
"6710215311558",  
"6710215114950",  
"6710217310406",  
"6710217212102",  
"6710217113798",  
"6710217015494",  
"6710217081030",  
"6710216720582",  
"6710216097990",  
"6710216032454",  
"6710215835846",  
"6710215344326",  
"6710215049414",  
"8609361592606",  
"8737245626654",
];
const skuToAppendCOD = [];

window.checkCODAvailability = function (skuList) {
  let ignoreCOD = false;
  let appendCOD = false;

  if (!Array.isArray(skuList)) {
    return null;
  }

  for (let i = 0; i < skuList.length; i++) {
    const currentSKU = skuList[i];
    if (typeof currentSKU !== "string") {
      return null;
    } else {
      if (skuToIgnoreCOD.includes(currentSKU)) {
        ignoreCOD = true;
      } else {
        appendCOD = true;
      }
    }
  }

  if (skuToAppendCOD.length > 0 && skuList.length > 0) {
    appendCOD = skuList.every((element) => skuToAppendCOD.includes(element));
  }

  if (ignoreCOD) {
    return false;
  }

  if (!ignoreCOD && appendCOD) {
    return true;
  }

  return null;
};